module.exports = __webpack_public_path__ + "static/osl_stairs_ankle-9f2661531e4932540d1ba638d06df68b.jpg";